<template>
    <div class="sw-modal bookings-list-dialog">
        <div v-click-outside="closeDialog" class="sw-modal-content">
            <div class="row sw-modal-heading">
                <div class="col text-center">
                    <h4>Bookings List</h4>
                </div>
            </div>
            <div class="sw-modal-body">
                <ul>
                    <li class="header">
                        <div><i class="fas fa-door-open"></i></div>
                        <div class="bookings-list-dialog__col-num"><i class="fas fa-moon"></i></div>
                        <div><i class="fas fa-bed"></i></div>
                        <div class="bookings-list-dialog__col-num"><i class="fas fa-male adult"></i><i class="fas fa-male adult"></i></div>
                    </li>
                    <li v-for="booking in bookings" :key="booking.id" v-on:click="selectBooking(booking)">
                        <div>{{ friendlyDate(booking.arrival) }}</div>
                        <div class="bookings-list-dialog__col-num">{{ getNumberOfNightsForBooking(booking) }}</div>
                        <div>
                            <div>
                                <span v-for="(room, index) in booking.rooms" v-bind:key="room.reference">
                                    {{room.name}}<template v-if="index+1 < booking.rooms.length">,<br></template>
                                </span>
                            </div>
                        </div>
                        <div class="bookings-list-dialog__col-num">{{getTotalGuestsForBooking(booking)}}</div>
                    </li>
                </ul>
            </div>
            <div class="sw-modal-actions">
                <div class="row">
                    <div class="col text-center">
                        <button @click="closeDialog" class="btn btn-primary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {datesMixin} from "../../mixins/DatesMixin"
import {bookingsMixin} from "../../mixins/BookingsMixin"

export default {
    name: 'ListBookingsDialog',
    props: {
        bookings: {
            type: Array,
            required: true
        }
    },
    mixins: [bookingsMixin, datesMixin],
    methods: {
        selectBooking(booking) {
            this.$root.$emit('show-trip', booking);
        },
        closeDialog() {
            this.$root.$emit('close-bookings-list-dialog');
        }
    }
};
</script>

<style lang="scss" scoped>
  @import "../../styles/components/modal.scss";
  @import "../../styles/components/list_bookings.scss";
</style>